import { Attachment } from '@assess/browser/api';

export const attachmentSort = (a: Attachment, b: Attachment) => {
  return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
};
